<template>
  <hr class="my-2 border-slate-300 dark:border-zinc-700" />
</template>
